import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../contexts/AuthContext';

const RequireAdmin = ({ children }) => {
  const { t } = useTranslation();
  const { user, profile, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return null;
  }

  if (!user) {
    const redirectTo = `${location.pathname}${location.search || ''}`;
    return <Navigate to={`/login?redirect=${encodeURIComponent(redirectTo)}`} replace />;
  }

  if (profile?.role !== 'admin') {
    return (
      <div className="auth-container">
        <h1 className="auth-title">{t('auth.admin.forbiddenTitle')}</h1>
        <p className="auth-subtitle">{t('auth.admin.forbiddenSubtitle')}</p>
      </div>
    );
  }

  return children;
};

// SECURITY WARNING:
// This component provides CLIENT-SIDE protection only.
// It improves UX by redirecting unauthorized users, but it MUST be paired
// with Row Level Security (RLS) policies on the Supabase backend.
// Never rely solely on this component to protect sensitive data or administrative actions.

export default RequireAdmin;
